import React from 'react';
import { Modal } from 'antd';
import { useHookstate } from '@hookstate/core';

/**
 * VideoPreview component renders a small video thumbnail. When the thumbnail is clicked,
 * it opens an Ant Design Modal containing a larger video player with controls enabled.
 * The click event propagation is stopped so that parent click handlers (e.g., opening
 * an ImageJobModal) are not triggered when the user only wants to preview the video.
 */
export function VideoPreview({
  src,
  width = 96,
  height = 96,
  pressable = true,
}) {
  // hookstate boolean for modal visibility
  const visible = useHookstate(false);

  const openModal = (e) => {
    if (!pressable) return;
    // Prevent parent onClick from firing (e.g., ImageJobItem card click)
    e?.stopPropagation?.();
    visible.set(true);
  };

  const closeModal = () => {
    visible.set(false);
  };

  return (
    <>
      {/* Video thumbnail */}
      <video
        width={width}
        height={height}
        src={src}
        // Autoplay/controls are disabled for the thumbnail to keep UI clean
        muted
        style={{
          objectFit: 'cover',
          borderRadius: 4,
          border: '1px solid #eee',
          cursor: 'pointer',
        }}
        onClick={openModal}
      />

      {/* Full-size player inside Modal */}
      <Modal
        open={visible.get()}
        footer={null}
        onCancel={closeModal}
        width={800}
        bodyStyle={{ padding: 0 }}
      >
        <video
          src={src}
          controls
          style={{ width: '100%', height: 'auto', borderRadius: 8 }}
          autoPlay
        />
      </Modal>
    </>
  );
}
